import z from 'zod'

export const frenchNumberSchema = z.preprocess(
  (val) => (typeof val === 'string' ? val.replace(',', '.') : val),
  z.coerce.number('La valeur doit être un nombre'),
)
